"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nthChildIterator = exports.classStyleHelper = exports.themeStyleHelper = exports.getElementCSSProperty = void 0;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // .......... GET CSS PROPERTY .......... //


var getElementCSSProperty = function getElementCSSProperty(element, property) {
  return window.getComputedStyle(element, null).getPropertyValue(property);
}; // .......... THEME HELPER .......... //
// loop each property in a theme and create styles with property infused
// example pass 'color' as themeProp, this will print '&.color-blue' in style sheet, then pass styles you want for that in "cb" function


exports.getElementCSSProperty = getElementCSSProperty;

var themeStyleHelper = function themeStyleHelper(theme, themeProp, cb) {
  var styleObj = {};
  Object.entries(theme[themeProp]).forEach(function (prop) {
    styleObj = Object.assign({}, styleObj, _defineProperty({}, "&.".concat(themeProp, "-").concat(prop[0]), cb(theme, prop[0])));
  });
  return styleObj;
}; // .......... CLASS STYLE HELPERS .......... //


exports.themeStyleHelper = themeStyleHelper;
var classStyleHelper = {
  align: {
    '&.align-center': {
      textAlign: 'center',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center'
    },
    '&.align-left': {
      textAlign: 'left',
      justifyContent: 'flex-start',
      alignContent: 'flex-start',
      alignItems: 'flex-start'
    },
    '&.align-right': {
      textAlign: 'right',
      justifyContent: 'flex-end',
      alignContent: 'flex-end',
      alignItems: 'flex-end'
    }
  },
  direction: {
    '&.direction-vertical': {
      display: 'flex',
      flexDirection: 'column'
    },
    '&.direction-horizontal': {
      display: 'flex',
      flexDirection: 'row'
    }
  }
}; // .......... NTH CHILD ITERATOR .......... //

exports.classStyleHelper = classStyleHelper;

var nthChildIterator = function nthChildIterator(numOfChildren, initialNum, numVariation) {
  var styleObj = {};
  var num = initialNum;

  for (var x = 0; x < numOfChildren; x++) {
    styleObj = Object.assign({}, styleObj, _defineProperty({}, "&:nth-child(".concat(x + 1, ")"), {
      animationDelay: "".concat(num, "s")
    }));
    num += numVariation;
  }

  return styleObj;
}; // extend: nthChildIterator(3, 0, .2)
// the above will print this:
// '&:nth-child(1)': { animationDelay: '.2s' },
// '&:nth-child(2)': { animationDelay: '.4s' },
// '&:nth-child(3)': { animationDelay: '.6s' }

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */


exports.nthChildIterator = nthChildIterator;